<template lang="pug">
aside.sidebar
  //- (@mouseleave="toggleSidebar(false)")
  //- vuestic-scrollbar
  ul.sidebar-menu
    li(v-for='(item, index) in myMenu')
      router-link.sidebar-link(:to='item.path', @click='toggleMenuItem(item)', v-if='item.path')
        i.sidebar-menu-item-icon(v-bind:class='item.meta.iconClass')
        |             {{item.meta.title}}
      a.sidebar-link(href='#', @click.prevent='toggleMenuItem(item)', v-bind:class='{expanded: item.meta.expanded}', v-else='')
        i.sidebar-menu-item-icon(v-bind:class='item.meta.iconClass')
        |             {{item.meta.title}}
        i.expand-icon.fa.fa-angle-down
      expanding
        ul.sidebar-submenu.in(v-show='item.meta.expanded')
          li(v-for='childItem in item.children' v-bind:class='{divider: childItem.meta.divider}')
            router-link.sidebar-link.sidebar-submenu-link(:to='childItem.path')
              i.submenu-icon(:class="computedClass(childItem.meta)")
              |  {{childItem.meta.title}}
</template>

<script>
import axios from 'axios'
import {mapGetters, mapActions} from 'vuex'
import Expanding from '../../../../node_modules/vue-bulma-expanding/src/Expanding'
import VuesticScrollbar from '../../vuestic-components/vuestic-scrollbar/VuesticScrollbar'
import {
  EventBus
} from '../../eventBus.js'

export default {
  name: 'sidebar',
  components: {
    Expanding,
    VuesticScrollbar
  },
  created () {
    this.fetchProjects()
    EventBus.$on('fetchItems', clickCount => {
      this.fetchProjects()
    })
  },
  methods: {
    ...mapActions({
      expand: 'toggleExpandMenuItem',
      toggleSidebar: 'hoverSidebar'
    }),
    computedClass (item) {
      return item.icon || ''
    },
    fetchProjects () {
      this.myMenu = []
      axios.get(`projects`).then((res) => {
        if (res.data.length < 1) {
          this.myMenu.push({
            name: 'New Project',
            path: '/newproject',
            meta: {
              title: 'New Project',
              iconClass: 'fa fa-plus'
            }
          })
          this.$router.push('/newproject')
        } else if (res.data) {
          this.myMenu = []
          res.data.forEach((project) => {
            const item = {
              name: project.name,
              meta: {
                expanded: false,
                title: project.name,
                projectId: project._id,
                iconClass: 'vuestic-icon vuestic-icon-dashboard',
                url: project.url
              },
              children: [
                {
                  name: 'Dash',
                  path: '/project/' + project._id + '/dash',
                  meta: {
                    default: false,
                    title: 'Dashboard',
                    url: project.url,
                    icon: 'fa fa-dashboard'
                  }
                },
                {
                  name: 'PageXplorer',
                  path: '/project/' + project._id + '/pagexplorer',
                  meta: {
                    default: false,
                    title: 'PageXplorer',
                    url: project.url,
                    divider: true,
                    icon: 'fa fa-search'
                  }
                },
                {
                  name: 'KeyXplorer',
                  path: '/project/' + project._id + '/keyxplorer',
                  meta: {
                    default: false,
                    title: 'KeyXplorer',
                    url: project.url,
                    icon: 'fa fa-search'
                  }
                },
                {
                  name: 'ErrorXplorer',
                  path: '/project/' + project._id + '/errors',
                  meta: {
                    default: false,
                    title: 'ErrorXplorer',
                    url: project.url,
                    icon: 'fa fa-search'
                  }
                },
                {
                  name: 'PageTracker',
                  path: '/project/' + project._id + '/pagetracker',
                  meta: {
                    default: false,
                    title: 'PageTracker',
                    url: project.url,
                    divider: true,
                    icon: 'fa fa-line-chart'
                  }
                },
                {
                  name: 'KeyTracker',
                  path: '/project/' + project._id + '/keytracker',
                  meta: {
                    default: false,
                    title: 'KeyTracker',
                    url: project.url,
                    icon: 'fa fa-line-chart'
                  }
                },
                {
                  name: 'Settings',
                  path: '/project/' + project._id + '/settings',
                  meta: {
                    default: false,
                    title: 'Settings',
                    divider: true,
                    icon: 'fa fa-cog'
                  }
                }

              ]
            }
            this.myMenu.push(item)
            if (this.$route.path === '/' || this.$route.path === '/project') {
              this.$router.push('/project/' + this.myMenu[0].meta.projectId + '/dash')
            }
          })
          if (JSON.parse(localStorage.getItem('mainuser'))) {
            this.myMenu.push({
              name: 'New Project',
              path: '/newproject',
              meta: {
                title: 'New Project',
                iconClass: 'fa fa-plus'
              }
            })
          }
        }
        setTimeout(() => this.toggleMenu(this.$route), 200)
      }).catch((e) => console.log(e))
    },
    toggleMenuItem (item) {
      if (item.children) {
        this.expand({ // TODO: check default prop
          menuItem: item,
          expand: !item.meta.expanded
        })
      }
    },
    toggleMenu (route) {
      if (!this.myMenu || !this.sidebarOpened) return
      let parent = _findMatchingParentMenuItem.call(this, route.name, route.params.id) || {}
      console.log(parent)
      this.myMenu.forEach((item) => {
        this.expand({
          menuItem: item,
          expand: parent.name === item.name
        })
      })
    }
  },
  computed: {
    ...mapGetters([
      'sidebarOpened'
    ])
  },
  watch: {
    $route (route) {
      this.toggleMenu(route)
    },
    sidebarOpened (newValue) {
      if (newValue) setTimeout(() => this.toggleMenu(this.$route), 200)
    }
  },
  data () {
    return {
      show: false,
      myMenu: []
    }
  }
}

function _findMatchingParentMenuItem (itemName, projectId) {
  let parentItem
  this.myMenu.forEach((item) => {
    parentItem = (item.children && item.children.find((child) => child.name === itemName) && item.meta.projectId === projectId) ? item : parentItem
  })

  return parentItem
}
</script>

<style lang="scss">
@import "../../../sass/_variables.scss";
@import "../../../../node_modules/bootstrap/scss/mixins/breakpoints";
@import "../../../../node_modules/bootstrap/scss/variables";

.sidebar-hidden .sidebar{
  display: none;
}

.sidebar {
  .sidebar-menu li {
            background: $sidebar-bg;
        }
    @include media-breakpoint-down(md) {
        top: $sidebar-mobile-top;
        left: $sidebar-mobile-left;
        width: $sidebar-mobile-width;
        z-index: $sidebar-mobile-z-index;
    }

    height: $sidebar-viewport-height;
    .vuestic-scrollbar {
        height: 100%;
        .scrollbar-wrapper {
            box-shadow: $sidebar-box-shadow;
        }
        .scrollbar-content {
            background: $sidebar-bg;
        }
    }

    position: absolute;
    width: $sidebar-width;
    top: $sidebar-top;
    left: $sidebar-left;
    transition: all 0.2s ease;
    opacity: 1;

    .sidebar-hidden_without-animation & {
        transition: none;
    }

    .sidebar-hidden & {
        @include media-breakpoint-down(md) {
            top: $sidebar-hidden-top-mobile;
            opacity: 0;
            z-index: $sidebar-mobile-z-index;
            height: $sidebar-hidden-height-mobile;
        }
        top: $sidebar-hidden-top;
        opacity: 0;
        z-index: $min-z-index;

    }

    .sidebar-link {
        position: relative;
        height: $sidebar-link-height;
        padding-left: $sidebar-link-pl;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        text-decoration: none;

        &.router-link-active,
        &:hover {
            color: $white;
            background-color: $sidebar-link-active-bg;

            .expand-icon,
            .sidebar-menu-item-icon {
                color: $white;
            }
        }

        .expand-icon {
            position: absolute;
            right: $sidebar-arrow-right;
            top: calc(50% - #{$font-size-root}/2);
            font-weight: bold;
            transition: transform 0.3s ease;
        }

        &.expanded {
            .expand-icon {
                transform: rotate(180deg);
            }
        }

        .sidebar-menu-item-icon {
            font-size: $sidebar-menu-item-icon-size;
            color: $vue-green;
            margin-right: 14px;

            &.fa-dashboard {
                /* Temp fix */
                position: relative;
                top: -2px;
            }
        }
    }

    .sidebar-submenu-link {
        height: $sidebar-submenu-link-height;
    }

    .sidebar-menu,
    .sidebar-submenu {
        list-style: none;
        padding-left: 0;

        li {
            display: block;
            padding-left: 0;
        }
    }

    .sidebar-submenu {
        .sidebar-link {
            padding-left: 50px;
            font-size: $font-size-smaller;
        }
        .divider {
            border-top: 1px solid #acb5be;
        }
        .submenu-icon {
            margin-right: 10px;
            margin-top: -2px;
        }
        li {
           background-color: #4d657d;
        }
        background-color: #4d657d;
    }

    .sidebar-menu {
        max-height: 100%;
        margin-bottom: 0;
    }

    .expand-icon {
        color: $vue-green;
    }

    a {
        color: $white;
        text-decoration: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar/Sidebar.vue